module.exports = {
  "attachment": "Attachment",
  "plaintext": "Plain text",
  "image": "Image",
  "audio": "Audio",
  "video": "Video",
  "richtext": "Rich text",
  "presentation": "Presentation",
  "spreadsheet": "Spreadsheet",
  "pdfdocument": "PDF Document",
  "archive": "Archive",
  "code": "Code",
  "markup": "Markup"
}
;